import { GeoObject } from './GeoObject';
import type { GeoObjectOptions, GeoObjectTypes } from '@visualizer/types';

export abstract class EditableGeoObject<T extends GeoObjectTypes> extends GeoObject<T> {
    protected constructor(options: GeoObjectOptions<T>) {
        super(options);
    }
}
